import * as React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { antGrey } from '../styles/globalStyles';
import { StepItemLinkContainer, StepItemText, StepItemTextContainer } from './StepItem';
import Icon, { SignalFilled } from '@ant-design/icons';

interface AdditionalItemProps {
    itemText: string;
    route: string;
    icon: typeof SignalFilled;
    leftNode?: React.ReactNode;
}
const AdditionalItem = ({ itemText, route, icon, leftNode }: AdditionalItemProps) => {
    const match = useRouteMatch(route);
    const isActive = !!match;
    return (
        <li>
            <Link to={route}>
                <StepItemLinkContainer isActive={isActive}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', minWidth: 0 }}>
                        {leftNode}
                        <StepItemTextContainer>
                            <StepItemText>{itemText}</StepItemText>
                        </StepItemTextContainer>
                        <Icon
                            component={icon}
                            style={{ color: antGrey.grey7, paddingTop: '12px', paddingBottom: '12px' }}
                        />
                    </div>
                </StepItemLinkContainer>
            </Link>
        </li>
    );
};

export default AdditionalItem;
